import { render, staticRenderFns } from "./ShortcodeBox.vue?vue&type=template&id=0df29951"
import script from "./ShortcodeBox.vue?vue&type=script&lang=js"
export * from "./ShortcodeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports